import { useMemo } from 'react'
import type { RibbonSchema } from 'cms/schemaTypes/ribbons/ribbon'

import { getCMSLinkParams } from 'lib/sanity/links'

const getCTAParams = (cta: RibbonSchema['cta']) => {
  if (!cta) return { href: '', text: '' }
  const { href } = getCMSLinkParams(cta.link)

  return { href, text: cta.text }
}
const useCTAParams = (ribbon?: RibbonSchema | null) => {
  return useMemo(() => getCTAParams(ribbon?.cta), [ribbon?.cta])
}

export default useCTAParams
